// extracted by mini-css-extract-plugin
module.exports = {"versionStatus":"VersionStatus_versionStatus__rJH05"};